import React, { Component } from "react";
import { connect } from "react-redux";
import defaultImage from "../../../Images/dp.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class ProfileCard extends Component {
  render() {
    console.log(this.props);
    if (this.props.user.role.id === 9) {
      return (
        <div
          className="d-flex p-3 shadow-sm th-br-16 m-4"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
          }}
        >
          {this.props.user.studentData.student_photo ? (
            <Link to="/profilePic">
              <img
                src={`${this.props.user?.studentData?.student_photo}`}
                alt=""
                className="th-br-100"
                style={{ width: "50px" }}
              />
            </Link>
          ) : (
            <Link to="/profilePic">
              <img
                src={defaultImage}
                alt=""
                className="th-br-100 my-auto"
                style={{ width: "50px" }}
              />
            </Link>
          )}

          <div className="d-flex flex-column mx-3">
            <div className="th-fw-600 th-white th-18">
              {this.props.user?.user?.first_name}{" "}
              {this.props.user?.user?.last_name}
            </div>
            <div className="d-flex th-14 th-white py-1">
              <div className="">
                {this.props.user.student_class.class_name} {""}
                {this.props.user.student_section.section_name} {""}
              </div>
              <div className="ml-3">
                <li>
                  <span> {this.props.user.contact}</span>
                </li>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="d-flex p-3 shadow-sm th-br-16 m-4"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
          }}
        >
          {this.props.user?.staffData?.staff_image ? (
            <Link to="/profilePic">
              <img
                src={`${this.props.user?.staffData?.staff_image}`}
                alt=""
                className="th-br-100"
                style={{ width: "50px" }}
              />
            </Link>
          ) : (
            <Link to="/profilePic">
              <img
                src={defaultImage}
                alt=""
                className="th-br-100 my-auto"
                style={{ width: "50px" }}
              />
            </Link>
          )}

          <div className="d-flex flex-column mx-3">
            <div className="th-fw-600 th-white th-18">
              {this.props.user.user.first_name}
              {this.props.user.user.last_name}
            </div>
            <div className="d-flex th-14 th-white py-1">
              <div className="">
                <span>
                  {" "}
                  {this.props.user.role.name === "IS_SUPERADMIN" ? (
                    <div>SUPER ADMIN</div>
                  ) : this.props.user.role.name === "IS_ADMIN" ? (
                    <div>ADMIN</div>
                  ) : (
                    <div>
                      {this.props.user.staffData.designation.designation}
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps)(ProfileCard);
